var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#B4DBF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 30C40.5234 30 32 38.5234 32 49V56.8717C32 58.8173 33.7043 60.4 35.8 60.4H37.7C38.2039 60.4 38.6872 60.1998 39.0435 59.8435C39.3998 59.4872 39.6 59.0039 39.6 58.5V48.7283C39.6 48.2244 39.3998 47.7411 39.0435 47.3848C38.6872 47.0285 38.2039 46.8283 37.7 46.8283H35.9748C37.0312 39.4753 43.3582 33.8 51 33.8C58.6418 33.8 64.9688 39.4753 66.0252 46.8283H64.3C63.7961 46.8283 63.3128 47.0285 62.9565 47.3848C62.6002 47.7411 62.4 48.2244 62.4 48.7283V60.4C62.4 62.4957 60.6957 64.2 58.6 64.2H54.8V62.3H47.2V68H58.6C62.7914 68 66.2 64.5914 66.2 60.4C68.2957 60.4 70 58.8173 70 56.8717V49C70 38.5234 61.4766 30 51 30Z",
    fill: "#59595C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.bda11843f6810f5a81ee64bf864011aa.svg";
export { ForwardRef as ReactComponent };